import {MutationTree} from 'vuex';
import {EventInitState, SeedEvent} from '@/store/event/event.types';

export const EventMutations: MutationTree<EventInitState> = {
  ['mutationGetEvent'](state: EventInitState, payload: SeedEvent[]) {
    state.eventList = payload;
  },
  ['mutationGetEventTime'](state: EventInitState, payload: SeedEvent[]) {
    state.eventTime = payload;
  },
  ['mutationGetEventMember'](state: EventInitState, payload: SeedEvent[]) {
    state.eventMember = payload;
  },
  ['mutationGetEventMemberMain'](state: EventInitState, payload: SeedEvent[]) {
    state.eventMemberMain = payload;
  },
  ['mutationGetEventTotal'](state: EventInitState, payload: number) {
    state.eventTotal = payload;
  }
};
